/* assets/herroeping.js
   Publiek herroepingsformulier (EU-herroepingsrecht). Twee stappen:
   1) gegevens invullen, 2) controleren + bevestigen. Bij stap 1->2 wordt het
   ordernummer + e-mail live gevalideerd via de Edge Function 'withdrawal'
   (action 'lookup'). Een mislukte validatie blokkeert de herroeping niet:
   de klant kan zijn ingevoerde gegevens altijd bevestigen. Bij bevestigen
   (action 'confirm') wordt de herroeping opgeslagen en bevestigd per e-mail. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function validEmail(v) {
    return typeof v === 'string' && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v.trim());
  }

  var HEAD = 'font-family:var(--FONT-STACK-HEADING);font-weight:var(--FONT-WEIGHT-HEADING);font-style:var(--FONT-STYLE-HEADING);color:var(--wdr-heading,var(--COLOR-TEXT))';
  var CSS = [
    '.wdr__heading{' + HEAD + ';font-size:30px;line-height:1.15;margin:0 0 1rem}',
    '.wdr__intro{margin:0 0 1.25rem;line-height:1.6;max-width:680px}',
    '.wdr__notice{border:1px solid var(--wdr-border,var(--COLOR-BORDER));border-left:3px solid var(--wdr-accent,var(--BTN-PRIMARY-BG));background:rgba(0,0,0,.02);padding:1rem 1.25rem;margin:0 0 1.75rem;max-width:680px;line-height:1.55}',
    '.wdr__legal{font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);margin:1.75rem 0 0;max-width:680px;line-height:1.55}',
    '.wdr__panel{border:1px solid var(--wdr-border,var(--COLOR-BORDER));padding:1.75rem;max-width:680px}',
    '.wdr__field{display:block;margin:0 0 1.15rem}',
    '.wdr__label{display:block;font-size:var(--font-body-small);font-weight:600;color:var(--COLOR-TEXT);margin:0 0 .4rem}',
    '.wdr__opt{font-weight:400;color:var(--COLOR-TEXT-LIGHT)}',
    '.wdr__input,.wdr__textarea,.wdr__select{width:100%;padding:.8rem 1rem;border:1px solid var(--wdr-border,var(--COLOR-BORDER));border-radius:0;background:#fff;color:#1f2421;font-size:var(--font-body);font-family:inherit}',
    '.wdr__textarea{min-height:90px;resize:vertical}',
    '.wdr__input:focus,.wdr__textarea:focus,.wdr__select:focus{outline:none;border-color:var(--BTN-PRIMARY-BG)}',
    '.wdr__row{display:flex;gap:1rem;flex-wrap:wrap}',
    '.wdr__row .wdr__field{flex:1 1 220px}',
    '.wdr__err{display:block;color:#b3261e;font-size:var(--font-body-small);margin:.35rem 0 0;min-height:1em}',
    '.wdr__actions{display:flex;gap:.75rem;flex-wrap:wrap;margin-top:.5rem}',
    '.wdr__msg{font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);margin:.75rem 0 0;min-height:1em}',
    '.wdr__review{list-style:none;margin:0 0 1.25rem;padding:0}',
    '.wdr__review li{display:flex;justify-content:space-between;gap:1rem;padding:.6rem 0;border-bottom:1px solid var(--wdr-border,var(--COLOR-BORDER-LIGHT))}',
    '.wdr__review .k{color:var(--COLOR-TEXT-LIGHT)}',
    '.wdr__review .v{color:var(--COLOR-TEXT);text-align:right;font-weight:600}',
    '.wdr__sub{' + HEAD + ';font-size:20px;margin:0 0 1rem}',
    '.wdr__back{background:none;border:none;color:var(--COLOR-TEXT-LIGHT);cursor:pointer;font-size:var(--font-body-small);padding:.7rem 0;text-decoration:underline}',
    '.wdr__back:hover{color:var(--COLOR-TEXT)}',
    '.wdr__warn{border:1px solid var(--wdr-border,var(--COLOR-BORDER));border-left:3px solid var(--wdr-accent,var(--BTN-PRIMARY-BG));background:rgba(0,0,0,.02);padding:.9rem 1.1rem;margin:0 0 1.25rem;font-size:var(--font-body-small);line-height:1.5}',
    '.wdr__done{border:1px solid var(--wdr-border,var(--COLOR-BORDER));border-left:3px solid var(--wdr-accent,var(--BTN-PRIMARY-BG));padding:1.5rem 1.75rem;max-width:680px}',
    '.wdr__done h2{' + HEAD + ';font-size:22px;margin:0 0 .6rem}',
    '.wdr__done p{margin:0 0 .5rem;line-height:1.55}',
    '@media (max-width:600px){.wdr__heading{font-size:25px}.wdr__panel{padding:1.25rem}}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('wdr-styles')) return;
    var st = document.createElement('style');
    st.id = 'wdr-styles';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function initWidget(root) {
    var endpoint = root.dataset.endpoint || '';
    var anonKey = root.dataset.key || '';
    var contactEmail = root.dataset.contactEmail || 'shop@angelo.be';
    var prefillEmail = root.dataset.email || '';
    var stage = root.querySelector('[data-wdr-stage]');
    if (!stage) return;

    var data = { name: '', email: prefillEmail, order: '', reason: '', lookup: null };

    function post(body) {
      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + anonKey,
          'apikey': anonKey
        },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().catch(function () { return {}; }); });
    }

    // ---- Stap 1: gegevens invullen ----
    // De form-HTML voor wanneer we de stap opnieuw moeten tonen (knop "terug").
    // Bij de eerste render gebruiken we de server-side form uit de sectie (zie
    // bindForm), zodat de pagina-hoogte meteen klopt en de footer niet overlapt.
    function formHtml() {
      return '<form class="wdr__panel wdr__form" novalidate>' +
          '<div class="wdr__row">' +
            '<label class="wdr__field"><span class="wdr__label">Naam</span>' +
              '<input class="wdr__input" name="name" type="text" autocomplete="name" value="' + esc(data.name) + '" required>' +
              '<span class="wdr__err" data-err="name"></span></label>' +
            '<label class="wdr__field"><span class="wdr__label">E-mailadres</span>' +
              '<input class="wdr__input" name="email" type="email" autocomplete="email" value="' + esc(data.email) + '" required>' +
              '<span class="wdr__err" data-err="email"></span></label>' +
          '</div>' +
          '<label class="wdr__field"><span class="wdr__label">Ordernummer</span>' +
            '<input class="wdr__input" name="order" type="text" inputmode="numeric" placeholder="bv. #12345" value="' + esc(data.order) + '" required>' +
            '<span class="wdr__err" data-err="order"></span></label>' +
          '<label class="wdr__field"><span class="wdr__label">Reden <span class="wdr__opt">(optioneel)</span></span>' +
            '<textarea class="wdr__textarea" name="reason" placeholder="Je hoeft geen reden op te geven.">' + esc(data.reason) + '</textarea></label>' +
          '<div class="wdr__actions">' +
            '<button type="submit" class="wdr__next btn btn--primary btn--solid">Volgende</button>' +
          '</div>' +
          '<p class="wdr__msg" role="status" aria-live="polite"></p>' +
        '</form>';
    }

    function renderForm() {
      stage.innerHTML = formHtml();
      bindForm(stage.querySelector('.wdr__form'));
    }

    // Bindt de submit-afhandeling op een (server-side of opnieuw gerenderde) form.
    function bindForm(form) {
      if (!form) return;
      // Prefill alleen wanneer we al data hebben (na "terug"); laat anders de
      // server-side waarden (ingelogde klant) staan.
      if (data.name) form.name.value = data.name;
      if (data.order) form.order.value = data.order;
      if (data.reason) form.reason.value = data.reason;
      if (data.email && !form.email.value) form.email.value = data.email;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        data.name = form.name.value.trim();
        data.email = form.email.value.trim();
        data.order = form.order.value.trim();
        data.reason = form.reason.value.trim();

        var ok = true;
        function err(field, txt) {
          form.querySelector('[data-err="' + field + '"]').textContent = txt || '';
          if (txt) ok = false;
        }
        err('name', data.name ? '' : 'Vul je naam in.');
        err('email', validEmail(data.email) ? '' : 'Vul een geldig e-mailadres in.');
        err('order', data.order ? '' : 'Vul je ordernummer in.');
        if (!ok) return;

        var btn = form.querySelector('.wdr__next');
        var msg = form.querySelector('.wdr__msg');
        btn.disabled = true;
        msg.textContent = 'Even controleren…';

        post({ action: 'lookup', order: data.order, email: data.email })
          .then(function (res) {
            data.lookup = res && res.ok ? res : null;
            renderReview();
          })
          .catch(function () { data.lookup = null; renderReview(); });
      });
    }

    // ---- Stap 2: controleren + bevestigen ----
    function renderReview() {
      var lk = data.lookup;
      var rows = '';
      rows += '<li><span class="k">Naam</span><span class="v">' + esc(data.name) + '</span></li>';
      rows += '<li><span class="k">E-mailadres</span><span class="v">' + esc(data.email) + '</span></li>';
      rows += '<li><span class="k">Ordernummer</span><span class="v">' + esc(lk && lk.order_name ? lk.order_name : data.order) + '</span></li>';
      if (lk && lk.order_date) rows += '<li><span class="k">Besteld op</span><span class="v">' + esc(lk.order_date) + '</span></li>';
      if (lk && lk.total) rows += '<li><span class="k">Totaalbedrag</span><span class="v">' + esc(lk.total) + '</span></li>';
      if (data.reason) rows += '<li><span class="k">Reden</span><span class="v">' + esc(data.reason) + '</span></li>';

      var warn = '';
      if (!lk) {
        warn = '<div class="wdr__warn">We konden je bestelling niet automatisch terugvinden. Controleer je ordernummer en e-mailadres. Klopt alles? Je kan je herroeping toch bevestigen — we behandelen ze handmatig.</div>';
      } else if (lk.has_living) {
        warn = '<div class="wdr__warn"><strong>Let op:</strong> je bestelling bevat levende producten (planten/bloembollen). Die zijn wettelijk uitgesloten van het herroepingsrecht. Eventuele andere artikelen kan je wel herroepen; we nemen contact met je op.</div>';
      }

      stage.innerHTML =
        '<div class="wdr__panel">' +
          '<h2 class="wdr__sub">Controleer je gegevens</h2>' +
          warn +
          '<ul class="wdr__review">' + rows + '</ul>' +
          '<p style="margin:0 0 1.25rem;line-height:1.55">Door te bevestigen verklaar je dat je de bovenstaande bestelling herroept. Je ontvangt een bevestiging op ' + esc(data.email) + '.</p>' +
          '<div class="wdr__actions">' +
            '<button type="button" class="wdr__confirm btn btn--primary btn--solid">Bevestig herroeping</button>' +
            '<button type="button" class="wdr__back">← Gegevens aanpassen</button>' +
          '</div>' +
          '<p class="wdr__msg" role="status" aria-live="polite"></p>' +
        '</div>';

      stage.querySelector('.wdr__back').addEventListener('click', renderForm);
      stage.querySelector('.wdr__confirm').addEventListener('click', function () {
        var btn = stage.querySelector('.wdr__confirm');
        var msg = stage.querySelector('.wdr__msg');
        btn.disabled = true;
        msg.textContent = 'Versturen…';
        post({
          action: 'confirm',
          name: data.name,
          email: data.email,
          order: data.order,
          reason: data.reason,
          order_id: data.lookup ? data.lookup.order_id : null,
          order_name: data.lookup ? data.lookup.order_name : null
        }).then(function (res) {
          if (res && res.ok) {
            renderDone();
          } else {
            btn.disabled = false;
            msg.textContent = 'Er ging iets mis. Probeer het opnieuw of mail naar ' + contactEmail + '.';
          }
        }).catch(function () {
          btn.disabled = false;
          msg.textContent = 'Er ging iets mis. Probeer het opnieuw of mail naar ' + contactEmail + '.';
        });
      });
    }

    // ---- Klaar ----
    function renderDone() {
      stage.innerHTML =
        '<div class="wdr__done">' +
          '<h2>Je herroeping is ontvangen</h2>' +
          '<p>We hebben je herroeping voor bestelling ' + esc(data.lookup && data.lookup.order_name ? data.lookup.order_name : data.order) + ' goed ontvangen.</p>' +
          '<p>Je ontvangt een bevestiging op ' + esc(data.email) + '. We nemen contact met je op over de terugzending en terugbetaling.</p>' +
          '<p style="font-size:var(--font-body-small);color:var(--COLOR-TEXT-LIGHT);margin-top:1rem">Vragen? Mail naar <a href="mailto:' + esc(contactEmail) + '">' + esc(contactEmail) + '</a>.</p>' +
        '</div>';
      if (typeof stage.scrollIntoView === 'function') stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Gebruik de server-side gerenderde form als die er is; anders bouw 'm op.
    var serverForm = stage.querySelector('.wdr__form');
    if (serverForm) { bindForm(serverForm); } else { renderForm(); }
  }

  function init() {
    document.querySelectorAll('.wdr[data-endpoint]').forEach(function (root) {
      if (root.dataset.wdrInit) return;
      root.dataset.wdrInit = '1';
      injectCSS();
      initWidget(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
